import { Component, OnInit, Input, HostBinding } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TableRow } from '../../../../core/models/table-row.model';
import { UtilsService } from '../../../services/utils/utils.service';
import { GarantiasOpcionalesService } from '../../../../core/providers/services/garantias-opcionales/garantias-opcionales.service';
import { take, tap } from 'rxjs/operators';
import { Numbers } from 'src/app/utils/constants';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})
export class TableComponent implements OnInit {

  @Input() FORM_DATA: FormGroup;
  /**
   * @description Es la configuracion del formulario
   */
  @Input() DATA_CONFIG: any;

  @HostBinding('class.w_max') apply = true;

  INSURE_SELECTED: any;
  GARANTEE_DATA: any[] = [];
  /**
   * @description constructor
   * @params uSrv
   * @params garanteeSrv
   */
  constructor(
    private uSrv: UtilsService,
    private garanteeSrv: GarantiasOpcionalesService
  ) {
    this.uSrv = uSrv;
    this.garanteeSrv = garanteeSrv;
  }
  /**
   * @description metodo de inicio
   */
  ngOnInit(): void {
    this.INSURE_SELECTED = this.FORM_DATA.get(['insureSelected', 'chosed']).value;
    this.getGarantees();
  }
  /**
   * @description recuprar garantias
   */
  getGarantees(): void {
    const ID: number = this.FORM_DATA.get([this.INSURE_SELECTED, 'guaranteeLimitOfMedicalExpenses']).value.idProducto;
    this.garanteeSrv.getGaranteeOptional(ID)
      .pipe(
        take(1),
        tap((e: any) => {
          this.GARANTEE_DATA = e;
        })
      ).subscribe();
  }
  /**
   * @description incluye icono
   * @params item
   */
  getIncludedIcon(item: TableRow): string {
    let cuantia = 0;
    let classNameIcon = '';
    const GARANTEE_LIMIT: string = this.FORM_DATA.get([this.INSURE_SELECTED, 'guaranteeLimitOfMedicalExpenses']).value.name;
    if (GARANTEE_LIMIT) {
      cuantia = this.uSrv.stringToNumber(GARANTEE_LIMIT);
    }
    // Más de 30.000
    if (cuantia >= Numbers.number30000) {
      const TABLE_EL_VALUE: string = this.FORM_DATA
        .get(item.linkFormPath).value.name;
      const CUANTO: number = this.uSrv.stringToNumber(TABLE_EL_VALUE);
      if (CUANTO > 0) {
        classNameIcon = item.included.yes.classNameIcon;
      } else { classNameIcon = item.included.no.classNameIcon; }
    }
    if (cuantia === Numbers.number18000) {
      const RIKEDS: string = this.FORM_DATA.get([this.INSURE_SELECTED, 'insuredsPlayRiskSports']).value.name;
      const NUMBER_OF_RISKS: number = this.uSrv.stringToNumber(RIKEDS);
      if (NUMBER_OF_RISKS === 0) {
        classNameIcon = item.included.yes.classNameIcon;
      }
      if (NUMBER_OF_RISKS > 0) {
        classNameIcon = item.included.yes.classNameIcon;
      } else {
        classNameIcon = item.included.no.classNameIcon;
      }
    }
    return classNameIcon;
  }
  /**
   * @description chequea deshabilitado
   */
  checkDisabled(): boolean {
    let cuantia = 0;
    let deshabilitado = true;
    const GARANTEE_LIMIT: string = this.FORM_DATA.get([this.INSURE_SELECTED, 'guaranteeLimitOfMedicalExpenses']).value.name;
    if (GARANTEE_LIMIT) {
      cuantia = this.uSrv.stringToNumber(GARANTEE_LIMIT);
    }
    // Más de 30.000
    if (cuantia >= Numbers.number30000) {
      deshabilitado = false;
    } else { deshabilitado = true; }
    return deshabilitado;
  }

}
